"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlockNumber = exports.useListener = void 0;
var react_1 = require("react");
var useWeb3_1 = require("./useWeb3");
var useIsWindowVisible_1 = __importDefault(require("./useIsWindowVisible"));
var block_number_1 = require("../components/block-number");
var useListener = function () {
    var _a = (0, useWeb3_1.useActiveWeb3)(), chainId = _a.chainId, library = _a.library, active = _a.active;
    var _b = __read((0, react_1.useState)(0), 2), blockNumber = _b[0], setBlockNumber = _b[1];
    var windowVisible = (0, useIsWindowVisible_1.default)();
    var blockNumberCallback = (0, react_1.useCallback)(function (blockNumber) { return setBlockNumber(blockNumber); }, [setBlockNumber]);
    // attach/detach listeners
    (0, react_1.useEffect)(function () {
        if (!active || !library || !chainId || !windowVisible)
            return;
        library
            .getBlockNumber()
            .then(blockNumberCallback)
            .catch(function (error) {
            return console.error("Failed to get block number for chainId: ".concat(chainId), error);
        });
        library.on('block', blockNumberCallback);
        return function () {
            library.removeListener('block', blockNumberCallback);
        };
    }, [active, chainId, library, windowVisible, blockNumberCallback]);
    return blockNumber;
};
exports.useListener = useListener;
var useBlockNumber = function () {
    var blockNumber = (0, react_1.useContext)(block_number_1.Context);
    return blockNumber;
};
exports.useBlockNumber = useBlockNumber;
exports.default = exports.useBlockNumber;
